<template>
    <div v-show="visible">
        <el-dialog title="查看成绩" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="1100px">    
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="学生姓名"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <div style="width:160px;">
                    <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                </div>
            </div>
            &nbsp;
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            </div>

            <el-table
                :data="tempContent"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="600"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <template v-for="(item,index) in head">
                    <el-table-column :prop="item.column_name" :label="item.column_comment" :show-overflow-tooltip="true" :key="index"></el-table-column>
                </template>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                head:[],
                content:[],
                tempContent:[],
                form:{
                    name:"",
                    identityCard:""
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(heads,contents){
                this.visible=true;
                this.head=heads;
                this.content=contents;
                this.tempContent=contents;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){ // 查询
                this.tempContent=[];
                for(let i=0;i<this.content.length;i++){
                    let name=this.content[i].name;
                    let identityCard=this.content[i].identityCard;
                    if(this.form.name!="" && this.form.identityCard!=""){
                        if(name.indexOf(this.form.name)>-1 
                            && identityCard.indexOf(this.form.identityCard)>-1){
                              this.tempContent.push(this.content[i]);  
                        }
                    }else if(this.form.name!=""){
                        if(name.indexOf(this.form.name)>-1){
                            this.tempContent.push(this.content[i]);  
                        }
                    }else if(this.form.identityCard!=""){
                        if(identityCard.indexOf(this.form.identityCard)>-1){
                            this.tempContent.push(this.content[i]);  
                        }
                    }else{
                        this.tempContent.push(this.content[i]); 
                    }
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/score/LookScore.vue